import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import LoginSliceReducer from "./features/AuthSlice";
import StateSliceReducer from "./features/StateSlice";
import AsyncStorage from "@react-native-async-storage/async-storage";
import AddressSlice from "./features/AddressSlice";
import APIsDataSlice from "./features/APIsDataSlice";
import LocationSlice from "./features/LocationSlice";
import LoaderSlice from "./features/LoaderSlice";
import ParsistAPIsData from "./features/ParsistAPIsData";
import TempAuthSlice from "./features/TempAuthSlice";

const rootReducer = combineReducers({
  login: LoginSliceReducer,
  state: StateSliceReducer,
  address: AddressSlice,
  states: APIsDataSlice,
  location: LocationSlice,
  loader: LoaderSlice,
  parsistStates: ParsistAPIsData,
  tempAuth: TempAuthSlice,
});

const persistConfig = {
  key: "frontendRoot",
  storage: AsyncStorage,
  blacklist: ["state", "states", "loader", "parsistStates", "address"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

store.subscribe(() => {
  console.log("Store state:", store.getState());
});

export const persistor = persistStore(store);

persistor.subscribe(() => {
  const state = store.getState();
  console.log("Persisted state after rehydration:", state);
});
